import { InputType, QuestionKey } from '../model';
import type { CandidateRequirementsDTO } from '../model';

/**
 * The empty questionnaire: which keys exist and what `input_type` each carries.
 *
 * That is a statement about the domain rather than about any one screen's state, which is why it
 * lives in the entity instead of in a store. Copied verbatim from the legacy
 * `CandidateQuestionnaire.store.ts` — every `confirmed_info` starts `undefined`, and
 * `is_answered` starts false.
 */
export const initialCandidateRequirements: CandidateRequirementsDTO = {
  [QuestionKey.READY_FOR_JOB_OFFERS]: {
    question_key: QuestionKey.READY_FOR_JOB_OFFERS,
    job_requirements: true,
    confirmed_info: undefined,
    is_answered: false,
    input_type: InputType.BOOLEAN,
  },
  [QuestionKey.CERTIFICATES_AND_LICENSES]: {
    question_key: QuestionKey.CERTIFICATES_AND_LICENSES,
    job_requirements: [],
    confirmed_info: undefined,
    is_answered: false,
    input_type: InputType.ARRAY,
  },
  [QuestionKey.SALARY]: {
    question_key: QuestionKey.SALARY,
    job_requirements: { min: 0, max: 0 },
    confirmed_info: undefined,
    is_answered: false,
    input_type: InputType.RANGE_INPUT,
  },
  [QuestionKey.SHIFTS]: {
    question_key: QuestionKey.SHIFTS,
    job_requirements: [],
    confirmed_info: undefined,
    is_answered: false,
    input_type: InputType.ARRAY,
  },
  [QuestionKey.AVAILABLE_DAYS]: {
    question_key: QuestionKey.AVAILABLE_DAYS,
    job_requirements: [],
    confirmed_info: undefined,
    is_answered: false,
    input_type: InputType.ARRAY,
  },
  [QuestionKey.LIMITATIONS_AND_PREFERENCES]: {
    question_key: QuestionKey.LIMITATIONS_AND_PREFERENCES,
    job_requirements: [],
    confirmed_info: undefined,
    is_answered: false,
    input_type: InputType.ARRAY,
  },
  [QuestionKey.WORKING_HOURS_PER_WEEK]: {
    question_key: QuestionKey.WORKING_HOURS_PER_WEEK,
    job_requirements: { min: 0, max: 0 },
    confirmed_info: undefined,
    is_answered: false,
    input_type: InputType.RANGE_INPUT,
  },
  [QuestionKey.LANGUAGES]: {
    question_key: QuestionKey.LANGUAGES,
    job_requirements: [],
    confirmed_info: undefined,
    is_answered: false,
    input_type: InputType.ARRAY,
  },
};
